import { $DKD } from '@/conf/common.const.js';
import commonApi from "@/api/common.api.js";

export default {
    state: {
        newsList: [],
        citizenOpinionsData: [],
        keywordList: [],
        internetTvData: {},
        internetTvList: []
    },
    getters: {
        getNewsList(state) {
            return state.newsList;
        },
        getCitizenOpinionsData(state) {
            return state.citizenOpinionsData;
        },
        getKeywordList(state) {
            return state.keywordList;
        },
        getInternetTvData(state) {
            return state.internetTvData;
        },
        getInternetTvList(state) {
            return state.internetTvList;
        }
    },
    mutations: {
        SET_NEWS_LIST(state, newsList) {
            state.newsList = newsList;
        },
        SET_CITIZEN_OPINIONS_DATA(state, citizenOpinionsData) {
            state.citizenOpinionsData = citizenOpinionsData;
        },
        SET_KEYWORD_LIST(state, keywordList) {
            state.keywordList = keywordList;
        },
        SET_INTERNET_TV_DATA(state, internetTvData) {
            state.internetTvData = internetTvData;
        },
        SET_INTERNET_TV_LIST(state, internetTvList) {
            state.internetTvList = internetTvList;
        }
    },
    actions : {
        FETCH_NEWS_LIST({commit}, dispId) {
            var q = "pageSize=20";

            return commonApi.fetchNewsList(dispId, q)
                        .then(res => {
                            commit('SET_NEWS_LIST', res.data.data);
                        })
        },
        FETCH_CITIZEN_OPINIONS_DATA({commit}, params) {
            return commonApi.fetchPageReposDataList($DKD.EUNPYUNG_WANT, params)
                .then(res => {
                    commit('SET_CITIZEN_OPINIONS_DATA', res.data);
                })
        },
        FETCH_KEYWORD_LIST({commit}, q) {
            return commonApi.fetchListCountGroupByDataKdSqno($DKD.RESPONSE_CENTER, q)
                .then(res => {

                    res.data.data.sort((pre, cur) => {
                        return parseInt(pre.dataCnt) > parseInt(cur.dataCnt) ? -1 : parseInt(pre.dataCnt) < parseInt(cur.dataCnt) ? 1: 0;
                    });

                    commit('SET_KEYWORD_LIST', res.data.data);
                })
        },
        FETCH_INTERNET_TV_LIST({commit}, params) {
            return commonApi.fetchPageReposDataList($DKD.INTERNET_TV, params)
                .then(res => {
                    commit('SET_INTERNET_TV_DATA', res.data.data[0]);
                    commit('SET_INTERNET_TV_LIST', res.data.data);
                })
        }
    }
};
